<head>
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
      integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
      crossorigin="anonymous"
      referrerpolicy="no-referrer"
    />
  </head>
  <div class="main-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
  
    <!-- added d-none to hide this section -->
    <div class="d-none panel" style="margin-top: 8px">
      <div class="panel-body">
        <div class="row">
          <div
            class="col-md-3 col-lg-3 col-sm-3"
            *ngFor="let user of teamMembers; let i = index"
          >
            <div class="thumbnail dashTopRow">
              <div class="row text-center" style="padding: 2%; padding-bottom: 0">
                <h5 style="font-size: 16px; font-weight: 700">
                  {{ user.userNameAtApplication }}
                </h5>
              </div>
              <div class="row">
                <div class="col-md-5">
                  <div class="dgm">
                    <div class="totalTrainings">
                      {{ user.badgeName }} ({{ user.trainingCount }})
                    </div>
                    <canvas
                      id="MyChart{{ i }}"
                      [ngStyle]="addBadges(user.newBadge, user.trainingCount)"
                      style="height: 140px !important; width: 90% !important"
                    ></canvas>
                  </div>
                </div>
                <div class="col-md-7">
                  <div
                    style="overflow-y: auto; height: 180px; overflow-x: hidden"
                  >
                    <div
                      class="row"
                      *ngFor="let status of user.trainingCountList"
                      style="padding-left: 10%; margin-bottom: 2px"
                    >
                      <div
                        style="margin-bottom: 0px"
                        *ngIf="
                          status.levelStatus != 'Locked - Overdue(RM Approved)'
                        "
                      >
                        <button
                          class="trainingDashButton"
                          [ngStyle]="applyStyle(status.color)"
                          mat-stroked-button
                        >
                          {{ status.levelStatus }} ({{ status.trainingCount }})
                        </button>
                      </div>
                      <div
                        style="margin-bottom: 0px"
                        *ngIf="
                          status.levelStatus == 'Locked - Overdue(RM Approved)'
                        "
                      >
                        <button
                          class="trainingDashButton"
                          [ngStyle]="applyStyle('#92c278')"
                          mat-stroked-button
                        >
                          Locked - Overdue(RM) ({{ status.trainingCount }})
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="thumbnail md-5 card_block1">
    <div class="d-flex gap-5 mt-4 mb-3 row text-items-center">
        <div class="col-md-1" style="width:2%;margin-top:10%;">
            <span
              *ngIf="isPrevious"
              class="fa fa-angle-left"
              style="font-size: 30px; cursor: pointer;"
              (click)="previousClick()" (keydown.enter)="previousClick()"
            ></span>
            <span
              *ngIf="!isPrevious"
              class="fa fa-angle-left"
              style="font-size: 30px; opacity: 0.4; cursor: not-allowed"
            ></span>
          </div>
          <div class="col-md-10" style="width: 88%;">
            <div class="row">
              <div
                class="col-md-6 "
                *ngFor="
                  let user of teamMembers.slice(
                    initialCount,
                    pageCount
                  )
                "
              >
      
        <div class="d-flex gap-5 card_block" style="min-height: 330px;">
          <div>
            <h5 class="team_training_info mt-3">{{user.userNameAtApplication}}</h5>
            <img
              class="mt-4"
              src="../../../assets/img/{{user.newBadge}}.png"
              width="100px"
              height="100px"
              alt=""
            />
            <h5 class="team_training_info mt-3">{{user.badgeName}}</h5>
          </div>
          <div>
            <div class="d-flex row" style="width:120%;">
              <div class=" col-md-4" *ngFor="let status of user.trainingCountList" style="margin-bottom: 5%;">
                <div class="circular_indicator">
                  <mat-progress-spinner [color]="status.color" [value]="status.percentage">
                  </mat-progress-spinner>
                  <span class="progress_percentage team_progress_percentage">{{ status.percentage }}%</span>
                </div>
                <div class="d-flex align-items-center gap-1 mt-1">
                  <p class="team_training_status">{{status.levelStatus}}</p>
                  <img
                    src="../../../assets/img/training_module/right_arrow.svg"
                    width="12px"
                    height="12px"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
    </div>
    </div>
    <div class="col-md-1" style="width:2%;margin-top:10%;">
        <span
          *ngIf="isNext"
          class="fa fa-angle-right"
          style="font-size: 30px; cursor: pointer"
           (click)="nextClick()"(keydown.enter)="nextClick()"
        ></span>
        <span
          *ngIf="!isNext"
          class="fa fa-angle-right"
          style="font-size: 30px; opacity: 0.4; cursor: not-allowed"
        ></span>
      </div>
      </div>
    </div>
    </div>
  